<template lang="pug">
v-dialog(
  v-model="showDialog"
  fullscreen
  hide-overlay
  :persistent="persistent"
  :transition="false"
)
  .redesign-dialog__overlay.d-flex.justify-center.align-center.overflow-hidden(
    v-if="showDialog"
    @click.self="overlayClickClose"
  )
    v-overlay(
      :value="showDialog"
      :class="{ 'filter-blur-1': showDialog }"
      color="redesignBackground"
      opacity="0.4"
      :z-index="-1"
    )
    v-sheet.redesign-dialog__dialog-container.rounded-32.white.relative(
      :class="containerClass"
      v-bind="$attrs"
    )
      v-btn.absolute.top-0.right-0.ma-8.z-index-10(
        v-if="closeButton"
        icon
        color="black"
        @click="$emit('close')"
      )
        v-icon $iclose
      //- @click.stop.prevent="() => {}" WHY??
      slot(name="default")
</template>

<script>
export default {
  name: 'RedesignDialog',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    closeButton: {
      type: Boolean,
      default: false,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    containerClass: {
      type: String,
      default: '',
    },
  },

  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      },
    },
  },

  watch: {
    // value(v) {
    //   if (v) {
    //     document.body.style.position = 'fixed';
    //     document.body.style.width = '100%';
    //     document.body.style.top = `${window.scrollY}px`;
    //   } else {
    //     document.body.style.position = '';
    //     document.body.style.width = 'auto';
    //     document.body.style.top = '';
    //   }
    // },
  },

  methods: {
    overlayClickClose() {
      if (!this.persistent) this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.redesign-dialog {
  &__overlay {
    height: 100vh;
    width: 100vw;
  };

  &__dialog-container {
    max-width: 80vw;
    max-height: 80vh;
    box-shadow: 0px 0px 4px rgba(17, 24, 28, 0.16);
  }
}
</style>
